export default "__VITE_ASSET__2cbabf71__"